import { useEffect, useState } from 'react';

/**
 * True below the given viewport width (default: Bootstrap's md breakpoint,
 * i.e. phones). Live — updates on rotation/resize. Used to swap verbose
 * bracket-button labels for compact icon forms on small screens.
 */
export function useIsNarrow(maxWidthPx = 767.98): boolean {
  const query = `(max-width: ${maxWidthPx}px)`;
  const [narrow, setNarrow] = useState<boolean>(() => {
    try { return window.matchMedia(query).matches; } catch { return false; }
  });
  useEffect(() => {
    try {
      const mql = window.matchMedia(query);
      const onChange = (e: MediaQueryListEvent) => setNarrow(e.matches);
      setNarrow(mql.matches);
      // Older Safari/WebView MediaQueryList has no addEventListener — fall
      // back to the legacy addListener API so the value still tracks resizes.
      if (typeof mql.addEventListener === 'function') {
        mql.addEventListener('change', onChange);
        return () => mql.removeEventListener('change', onChange);
      }
      (mql as any).addListener(onChange);
      return () => (mql as any).removeListener(onChange);
    } catch { return undefined; }
  }, [query]);
  return narrow;
}

export default useIsNarrow;
